module.exports = "/_next/static/images/CallToAction2-c5032f559950a22d049bdc95cd446f6f.svg";